import { configureStore } from '@reduxjs/toolkit';
import generalSlice from './slices/generalSlice';
import authSlice from './slices/authSlice';
import businessSlice from './slices/businessSlice';

const store = configureStore({
  reducer: {
    general: generalSlice,
    auth: authSlice,
    business: businessSlice
  },
});

export default store;
